import { render, staticRenderFns } from "./puPlayer.vue?vue&type=template&id=205c25db&scoped=true&"
import script from "./puPlayer.vue?vue&type=script&lang=js&"
export * from "./puPlayer.vue?vue&type=script&lang=js&"
import style0 from "./puPlayer.vue?vue&type=style&index=0&id=205c25db&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205c25db",
  null
  
)

export default component.exports